module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "px-3": "",
      "py-3": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.notificationTypesList,
      "label": "Select notification type"
    },
    model: {
      value: (_vm.selectedNotificationTypes),
      callback: function($$v) {
        _vm.selectedNotificationTypes = $$v
      },
      expression: "selectedNotificationTypes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.eventsList,
      "label": "Select an event"
    },
    model: {
      value: (_vm.selectedEvent),
      callback: function($$v) {
        _vm.selectedEvent = $$v
      },
      expression: "selectedEvent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Message",
      "rows": "5"
    },
    model: {
      value: (_vm.notificationMessage),
      callback: function($$v) {
        _vm.notificationMessage = $$v
      },
      expression: "notificationMessage"
    }
  })], 1), _vm._v(" "), (!_vm.isLeadAddedEvent) ? _c('v-flex', {
    staticClass: "pl-2",
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$case_id!!}')
      }
    }
  }, [_vm._v("Case ID")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$case_name!!}')
      }
    }
  }, [_vm._v("Case name")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$quotation_link!!}')
      }
    }
  }, [_vm._v("Quotation link")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$agreement_link!!}')
      }
    }
  }, [_vm._v("Agreement link")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$date_time_of_funerals!!}')
      }
    }
  }, [_vm._v("Date time of funerals")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$amount_of_days!!}')
      }
    }
  }, [_vm._v("Amount of days")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$location!!}')
      }
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_package!!}')
      }
    }
  }, [_vm._v("Selected Package")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_casket!!}')
      }
    }
  }, [_vm._v("Selected Casket")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_products!!}')
      }
    }
  }, [_vm._v("Selected Products")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_products_list_text!!}')
      }
    }
  }, [_vm._v("Selected Products-Amount List Text")])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Recipients (comma-separated values)",
      "rows": "2"
    },
    model: {
      value: (_vm.notificationRecipients),
      callback: function($$v) {
        _vm.notificationRecipients = $$v
      },
      expression: "notificationRecipients"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.roles,
      "chips": "",
      "label": "Roles",
      "multiple": "",
      "outline": ""
    },
    model: {
      value: (_vm.selectedRoles),
      callback: function($$v) {
        _vm.selectedRoles = $$v
      },
      expression: "selectedRoles"
    }
  })], 1), _vm._v(" "), (!_vm.isLeadAddedEvent) ? _c('v-flex', [_c('v-checkbox', {
    attrs: {
      "label": "Send to case Client?"
    },
    model: {
      value: (_vm.sendToClient),
      callback: function($$v) {
        _vm.sendToClient = $$v
      },
      expression: "sendToClient"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is active?"
    },
    model: {
      value: (_vm.notificationIsActive),
      callback: function($$v) {
        _vm.notificationIsActive = $$v
      },
      expression: "notificationIsActive"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.saveNotification
    }
  }, [_vm._v("Save settings")])], 1)], 1), _vm._v(" "), _c('AppEditTwilioNotificationsDialog'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.vendor))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.message))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.event.description || props.item.event.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.recipients_string))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRoleNamesByIds(props.item.roles)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.send_to_client))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.is_active))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('ConfirmationDialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "teal",
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "text-xs-center"
  }, [_vm._v("Built in notifications")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("chat_bubble")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Case Manager Changed")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Old manager and new will receive sms message: \"Hello! Case Manager for case #x has been changed.\"")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("chat_bubble")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Products Changed In Case")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Case manager (email) and each attached vendor (sms and email) will receive notification with information about changed product")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("chat_bubble")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Products Detached From Case")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Each attached vendor will receive sms with information about detached product")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78b52999","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resources/Notifications.vue
// module id = 991
// module chunks = 1